import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogCategoryForm from "./BlogCategoryForm";
import { createBlog } from "../../api/BlogCategoryService";

const BlogCategoryadd = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const payload = {
        name: values.name,
        description: values.description,
        status: values.status,
      };

      const res = await createBlog(payload);

      if (res.success) {
        navigate("/blogcategory");
        return;
      }

      // Backend validation error if response comes with success false
      if (res.error) {
        setErrors(res.error);
      }
    } catch (error) {
      console.error("Create Blog Category Error:", error);

      if (error?.response?.data?.error) {
        setErrors(error.response.data.error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogCategoryForm
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onCancel={() => navigate("/blogcategory")}
    />
  );
};

export default BlogCategoryadd;
